import * as types from './types';

/**
 * Password Entered Action
 *
 * @param {boolean} isPasswordCorrect
 * @returns {{type: string, isPasswordCorrect: boolean}}
 */
export const passwordEntered = isPasswordCorrect => {
	return { type: types.PASSWORD_ENTERED, isPasswordCorrect };
};



// WEBPACK FOOTER //
// ./src/actions/Security/actions.js